<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">

  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">Stock To Asset</div>
        <div class="transaction-section-header-actions header-actions">
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span><img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" /></span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 col-lg-6 small-pad-right">
      <div [ngClass]="isGeneralInformationExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
        <div class="row">

          <!-- <div class="col-12">
          <p class="titleStandardStyle">General Information</p>
        </div> -->


        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">General Information</span>
          <span [ngClass]="isGeneralInformationExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
            class="float-right pointer-click"
          (click)="ExpandCollapseGeneralInfoWidget(isGeneralInformationExpanded)"></span>
        </div>


        @if (isGeneralInformationExpanded) {
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Date/Time</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker formControlName="startDate" class="newFormControlWidth"
                    placeholder="Start Date and Time"
                    [format]="_datePickerFormat"
                    [attr.disabled]="_dateEnabled ? null : 'disabled'">
                  </kendo-datetimepicker>
                </div>
              </div>
            </div>
          </div>
          @if (_currentUser && _currentUser.isEnterprise) {
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Account</label>
                  </div>
                  <div class="col-10 transaction-input-fields">
                    <kendo-combobox #kendo_combo_accounts [filterable]="true" [suggest]="true"
                      [placeholder]="'Choose an Account'" class="bordered newFormControlWidth" required>
                    </kendo-combobox>
                    <a class="cursor-pointer">
                      <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          }
          <sites-dropdown #kendo_combo_sites
            layout="transaction"
            [showAllSites]="true"
            [labelText]="'Site'"
            [inputContainerClass]="'transaction-input-fields'"
            formControlName="site"
            [placeholder]="'Choose a Site'"
            [textField]="'name'"
            [valueField]="'id'"
            class="bordered newFormControlWidth"
            [required]="true">
          </sites-dropdown>
          <div class="col-12">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2"><label class="control-label">Location</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox #kendo_combo_location [filterable]="true"
                    [suggest]="true"
                    [placeholder]="'Choose a Location'"
                    class="bordered newFormControlWidth" required>
                  </kendo-combobox>
                  <a class="cursor-pointer">
                    <img class="searchIcon"
                      [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2"><label class="control-label">Customer</label></div>
                  <div class="col-10 transaction-input-fields">
                    <kendo-combobox [filterable]="true" [suggest]="true" [placeholder]="'Choose a Customer'" class="newFormControlWidth">
                    </kendo-combobox>
                    <a class="cursor-pointer">
                      <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2"><label class="control-label">Transaction Notes</label></div>
                  <div class="col-10 transaction-input-fields">
                    <input type="text" class="k-textbox writebox newFormControlWidth" placeholder="Notes.." />
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 small-pad-left">
      <div [ngClass]="isScanInventoryExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
        <div class="row">

          <!-- <div class="col-12">
          <p class="titleStandardStyle">Scan Inventory ID#</p>
        </div> -->


        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">Scan Inventory ID#</span>
          <span [ngClass]="isScanInventoryExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
            class="float-right pointer-click"
          (click)="ExpandCollapseScanInventoryWidget(isScanInventoryExpanded)"></span>
        </div>

        @if (isScanInventoryExpanded) {
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup display-flex">
              <div class="row flex-1">
                <div class="col-2"><label class="control-label">Inventory ID#</label></div>
                <div class="col-10 transaction-input-fields">
                  <kendo-combobox [filterable]="true" [placeholder]="'Inventory ID'" class="bordered newFormControlWidth" required>
                  </kendo-combobox>
                  <span class="asap-input-icon">
                    <img class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                  </span>
                </div>
              </div>
              <div class="transactions-stock-right-checkbox">
                <input type="checkbox" class="k-checkbox"
                  kendoCheckBox />
                  <div class="transactions-stock-right-checkbox-text">Quick Scan</div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group special_style_formgroup display-flex">
                <div class="row flex-1">
                  <div class="col-2">
                    <label class="control-label">
                      Asset#
                    </label>
                  </div>
                  <div class="col-10 transaction-input-fields">
                    <input type="text" class="k-textbox writebox newFormControlWidth"
                      [placeholder]="'Asset#'"
                      required />
                      <a class="cursor-pointer">
                        <img class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'">
                        </a>
                      </div>
                    </div>
                    <div class="transactions-stock-right-checkbox">
                      <input type="checkbox" class="k-checkbox"
                        kendoCheckBox />
                        <div class="transactions-stock-right-checkbox-text">Auto Generate</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group special_style_formgroup display-flex">
                      <div class="row flex-1">
                        <div class="col-2"><label class="control-label">From Location</label></div>
                        <div class="col-10 transaction-input-fields">
                          <kendo-combobox [filterable]="true" [placeholder]="'From Location'" class="bordered newFormControlWidth" required>
                          </kendo-combobox>
                        </div>
                      </div>
                      <div class="transactions-stock-right-checkbox">
                        <input type="checkbox" class="k-checkbox" kendoCheckBox />
                        <div class="transactions-stock-right-checkbox-text">Set as Default</div>
                      </div>
                    </div>
                    <div class="section-separator"></div>
                  </div>
                  <div class="col-12 margin-top-10">
                    <div class="form-group special_style_formgroup display-flex">
                      <div class="row flex-1">
                        <div class="col-2">
                          <label class="control-label">
                            Attached Document
                          </label>
                        </div>
                        <div class="col-10 transaction-input-fields">
                          <input type="text" class="k-textbox writebox" placeholder="Upload file.." />
                        </div>
                      </div>
                      <div class="transactions-stock-right-checkbox">
                        <input type="checkbox" class="k-checkbox"
                          kendoCheckBox />
                          <div class="transactions-stock-right-checkbox-text">Print Receipt</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="asap-section-container transactionWidget numericboxtab with-grid">
                <div class="col-12 mt-3 mb-2 flex-space-between transaction-receive-grid-header-wrapper">
                  <p class="titleStandardStyle">Selected Items</p>
                  <div class="transaction-receive-grid-top-actions d-flex">
                    <div class="transaction-receive-grid-top-actions-radio mr-3">
                      <input type="radio" id="new-to-old-items" name="transaction-receive-duration" value="new"
                        [formControl]="_sortingSelected" kendoRadioButton />
                        <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                      </div>
                      <div class="transaction-receive-grid-top-actions-radio">
                        <input type="radio" id="old-to-new-items" name="transaction-receive-duration" value="old"
                          [formControl]="_sortingSelected" kendoRadioButton />
                          <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                        </div>
                      </div>
                    </div>
                    <kendo-grid [data]="_stockToAssetGridData" [scrollable]="'none'" class="asap-standalone-grid">

                      <kendo-grid-column field="inventoryId" title="Inventory ID#">
                      </kendo-grid-column>

                      <kendo-grid-column field="assetId" title="Asset#">
                      </kendo-grid-column>

                      <kendo-grid-column field="stockDescription" title="Stock Description">
                      </kendo-grid-column>

                      <kendo-grid-column field="model" title="Model">
                      </kendo-grid-column>

                      <kendo-grid-column field="serial" title="Serial">
                      </kendo-grid-column>

                      <kendo-grid-column field="fromLocation" title="From Location">
                      </kendo-grid-column>

                      <kendo-grid-column field="availableQty" title="Available Quantity">
                      </kendo-grid-column>

                      <kendo-grid-column field="issueUOM" title="Issue U/M">
                      </kendo-grid-column>

                      <kendo-grid-column field="inventoryUnitQty" title="Inventory Unit Quantity">
                      </kendo-grid-column>

                      <kendo-grid-column field="unitCost" title="Unit Cost">
                      </kendo-grid-column>

                      <kendo-grid-column field="overridePrice" title="Override Price">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <input type="checkbox" class="k-checkbox" kendoCheckBox />
                        </ng-template>
                      </kendo-grid-column>

                      <kendo-grid-command-column title="Action">
                        <ng-template kendoGridCellTemplate>
                          <div kendoGridRemoveCommand class="asap-grid-remove">
                            <div class="asap-grid-remove-icon">
                              <img src="/assets/menu/enterprise/remove-icon.svg" />
                            </div>
                            <div class="asap-grid-remove-text">
                              Delete
                            </div>
                          </div>
                        </ng-template>
                      </kendo-grid-command-column>

                    </kendo-grid>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  @if (_invalidForm) {
                    <asap-forms-validation-summary [form]="_form" [page]="'physical-inventory'">
                    </asap-forms-validation-summary>
                  }
                </div>
              </div>
            </form>
